import { format } from 'date-fns';

export function calculatePriceStats(
  currentPrice: number,
  priceHistory: { base_price: number; created_at: string }[]
) {
  // Group prices by date
  const pricesByDate = priceHistory.reduce(
    (acc, { base_price, created_at }) => {
      if (!acc[created_at]) {
        acc[created_at] = [];
      }
      acc[created_at].push(base_price);
      return acc;
    },
    {} as Record<string, number[]>
  );

  // Get lowest price for each date
  const dailyLowestPrices = Object.entries(pricesByDate).map(
    ([date, prices]) => ({
      date,
      price: Math.min(...prices),
    })
  );

  // Find overall stats from daily lowest prices
  const allTimeLow = dailyLowestPrices.reduce(
    (min, curr) => (curr.price < min.price ? curr : min),
    dailyLowestPrices[0]
  );

  const allTimeHigh = dailyLowestPrices.reduce(
    (max, curr) => (curr.price > max.price ? curr : max),
    dailyLowestPrices[0]
  );

  const average =
    dailyLowestPrices.reduce((sum, curr) => sum + curr.price, 0) /
    dailyLowestPrices.length;

  const percentFromLow =
    ((currentPrice - allTimeLow.price) /
      (allTimeHigh.price - allTimeLow.price)) *
    100;

  return {
    allTimeLow: allTimeLow.price,
    allTimeHigh: allTimeHigh.price,
    lowestDate: allTimeLow.date,
    highestDate: allTimeHigh.date,
    average,
    percentFromLow,
  };
}
